import React from "react";
import {isMonetaryKpi} from "./PerformanceValue";
import styled from "styled-components";

const CurrencyContainer = styled.div`
    font-size: 10px;
`;

export default ({kpi, value, currency, className}) => (
    value && isMonetaryKpi(kpi) ? <CurrencyContainer className={className}>{currency}</CurrencyContainer> : null
);